import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL BLOGS -------------------- */
export const AllBlogsThunk = createAsyncThunk(
  "blogs/AllBlogsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/blogs/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch blogs");
    }
  }
);

/* -------------------- GET SINGLE BLOG -------------------- */
export const GetSingleBlogsThunk = createAsyncThunk(
  "blogs/GetSingleBlogsThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/blogs/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch blog details"
      );
    }
  }
);

/* -------------------- ADD BLOG -------------------- */
export const AddBlogsThunk = createAsyncThunk(
  "blogs/AddBlogsThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/blogs/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add blog");
    }
  }
);

/* -------------------- UPDATE BLOG -------------------- */
export const UpdateBlogsThunk = createAsyncThunk(
  "blogs/UpdateBlogsThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/blogs/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update blog");
    }
  }
);

/* -------------------- DELETE BLOG -------------------- */
export const DeleteBlogsThunk = createAsyncThunk(
  "blogs/DeleteBlogsThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/blogs/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete blog");
    }
  }
);

/* -------------------- ALL BLOGS -------------------- */
export const AllBlogsCategoryThunk = createAsyncThunk(
  "blogs/AllBlogsCategoryThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/blog-category/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch blogs");
    }
  }
);
